<!-- <connection-alert></connection-alert> -->
<div class="container">
  <div class="scrollable-content">
    <simple-header title="Reparación de mantenimiento" [back]="true" icon="close"></simple-header>
    <div class="item">
      <div class="padding-top-8 padding-bottom-8" *ngIf="!loading && !maintenance">
        <app-alert-dialog
            text="No se pudieron recuperar los datos del mantenimiento. Vuelva al dashboard e inténtelo de nuevo."
            status="advise"></app-alert-dialog>
      </div>
      <app-list-step-state-item
        [state]="this.maintenance?.project?.id && taskIdentificationCompleted ? 'COMPLETED': 'PENDING'"
        [disabled]="pendingRequest || !assigned || (closed && !pendingSyncAStep)"
        (click)="openTaskIdentificationDialog()"
        title="Identificación de la labor"
        [description]="descriptionStep2">
      </app-list-step-state-item>
      <mat-divider></mat-divider>
      <app-list-step-state-item
        [state]="completedAnswersDailyQuestionary ? 'COMPLETED': (answersDailyPermission?.length ? 'IN_PROGRESS': 'PENDING')"
        [disabled]="!taskIdentificationCompleted || pendingSignMaintenanceTask || pendingRequest || completedAnswersDailyQuestionary || !assigned  || (closed && !pendingSyncAStep)"
        (click)="openDailyPermissionQuestionary()"
        title="Cuestionario diario para trabajar en alturas"
        [description]="descriptionStep0">
      </app-list-step-state-item>
      <mat-divider></mat-divider>
      <app-list-step-state-item
        [state]="(questionaryCompleted || completedAnswers >= 0) ? 'COMPLETED': 'PENDING'"
        (click)="openQuestionary()"
        [disabled]="pendingSignMaintenanceTask || pendingRequest || !completedAnswersDailyQuestionary || repairmentCompleted || !assigned || (closed && !pendingSyncAStep)"
        title="Confirmación de seguridad"
        [description]="descriptionStep1">
      </app-list-step-state-item>
      <mat-divider></mat-divider>
      <!-- <app-list-step-state-item
        [loading]="loadingDocumentationStep"
        (click)="signTask()"
        title="Firmar permiso de trabajo"
        [description]="descriptionStepSign">
      </app-list-step-state-item> -->
      <mat-divider></mat-divider>
      <app-list-step-state-item
        [state]="initialPhotosCompleted ? 'COMPLETED': 'PENDING'"
        [disabled]="pendingRequest || !questionaryCompleted || !assigned || (closed && !pendingSyncAStep)"
        (click)="openTakePhotos('initial')"
        title="Tomar fotos del estado inicial"
        [description]="descriptionStep3">
      </app-list-step-state-item>
      <mat-divider></mat-divider>
      <app-list-step-state-item
        [state]="repairmentCompleted ? 'COMPLETED': 'PENDING'"
        (click)="repair()"
        [disabled]="pendingRequest || !initialPhotosCompleted || !assigned || (closed && !pendingSyncAStep)"
        title="Reparar"
        [description]="descriptionStep4">
      </app-list-step-state-item>
      <mat-divider></mat-divider>
      <app-list-step-state-item
        [state]="finalPhotosCompleted ? 'COMPLETED': 'PENDING'"
        (click)="openTakePhotos('final')"
        [disabled]="pendingRequest || !repairmentCompleted || !assigned || (closed && !pendingSyncAStep)"
        title="Tomar fotos del estado final"
        [description]="descriptionStep5">
      </app-list-step-state-item>
      <mat-divider></mat-divider>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="pendingRequest"></mat-progress-bar>
    <div class="padding-top-8 padding-bottom-8" *ngIf="assigned && observationsInMaintenanceQuestionary && !maintenanceTask && !pendingSync">
      <app-alert-dialog
        (click)="postponeMaintenance()"
        text="Existen disconformidades en la confirmación de seguridad. Puede posponer la tarea para reanudarla otro día."
        linkText="Generar documentación y posponer tarea"
        status="advise"></app-alert-dialog>
    </div>
    <div class="padding-top-8 padding-bottom-8" *ngIf="pendingIdenfifyLuminary && assigned">
      <app-alert-dialog
        (click)="goToLuminary()"
        text="La luminaria {{this.maintenance.luminary.number}} no existe. Puede modificarla en el paso Identificación de la labor o registrarla. ¿Quiere censarla?."
        linkText="Censar luminaria {{this.maintenance.luminary.number}}"
        status="advise"></app-alert-dialog>
    </div>
    <div class="padding-top-8 padding-bottom-8" *ngIf="maintenanceTask && pendingSignByMe">
      <app-alert-dialog
          (click)="signTask()"
          text="Pendiente de firmar el permiso de trabajo."
          linkText="Ir a tarea de firma"
          status="advise"></app-alert-dialog>
    </div>
    <div class="padding-top-8 padding-bottom-8" *ngIf="invalidSelectedProject && assigned">
      <app-alert-dialog
          text="No se pudo comprobar el proyecto seleccionado. Para finalizar el proceso tienes que seleccionar de nuevo el proyecto"
          status="advise"></app-alert-dialog>
    </div>
    <div *ngIf="assigned && !closed && !observationsInMaintenanceQuestionary" class="align-center padding-top-8">
      <button [disabled]="pendingRequest || !completedSteps" mat-raised-button color="primary" (click)="closeMaintenance()" class="button-size-200">Cerrar mantenimiento</button>
    </div>
    <div *ngIf="assigned && !invalidSelectedProject && pendingSync && !(maintenance.pendingSync?.create && !closed )" class="align-center padding-top-8">
      <button [disabled]="pendingRequest" mat-button (click)="syncRepairmentData(maintenance)" class="button-size-200">
        <mat-icon class="icon-button">cloud_upload</mat-icon>Sincronizar
      </button>
    </div>
  </div>
</div>
